// extracted by mini-css-extract-plugin
export default {"main":"ConsultPublicScoringUser_main__FXt8f"};